import styled from 'styled-components';

import { smoothTransition, positionAbsoluteCenter } from '../../Styles/mixins'
import { primaryColor } from '../../Styles/variables'

export const Container = styled.div`
  ${smoothTransition};
  ${positionAbsoluteCenter(-10,50)} 
  display: block;
  max-width: 450px;
  width: 100%;
  padding: 1rem;
  box-shadow: 0 0 2rem rgba(0,0,0, .5);
  border-radius: 5px;
  z-index: 100;
  background: #fff; 
  text-align: center;

  h1 { 
    text-transform: uppercase;
    color: #D00;
    margin-bottom: 1rem;
  } 

  p { 
    color: ${primaryColor};
  }


  &.visible {
    top: 16%;
  }
`;
